import styled from "@emotion/styled"
import {IconWrapper} from "@components/shared/FormFields/styles"

export const SelectWrapper = styled("div", {
    shouldForwardProp: prop => prop !== 'noBorder' && prop !== 'wrapperBorder' && prop !== 'smallBorder',
})<{noBorder?: boolean, wrapperBorder?: boolean, smallBorder?: boolean}>(({theme, noBorder, wrapperBorder}) => ({
    width: "100%",
    maxWidth: "none",
    borderBottom: wrapperBorder ? "2px solid rgba(0, 0, 0, .2)" : "",
    "& input": {
        borderBottom: noBorder ? "none" : "1px solid #858585",
    },
    marginTop: "0px !important",
    marginBottom: 0,
    padding: "0 !important",
}))

export const Select = styled("select", {
    shouldForwardProp: prop => !["isDisabled", "hasError"].includes(String(prop)),
})<{ isDisabled: boolean, hasError: boolean}>(({
                                                                      theme,
                                                                      isDisabled,
                                                                      hasError
                                                                  }) => ({
    border: "2px solid",
    width: "100%",
    borderRadius: 6,
    height: "100%",
    paddingLeft: 16,
    boxSizing: "border-box",
    background: theme.colors.N0,
    fontSize: theme.fonts.pxToRem(16),
    flex: "0 0 100%",
    margin: 0,
    color: theme.colors.N500,
    appearance: "none",
    [`&, & + ${IconWrapper}`]: {
        borderColor: hasError ? theme.colors.Y300 : theme.colors.N50
    },
    "&:not([disabled]):hover": {
        [`&, & + ${IconWrapper}`]: {
            borderColor: isDisabled ? theme.colors.N50 : theme.colors.N80,
        },
    },
    "&:focus": {
        [`&, & + ${IconWrapper}`]: {
            borderColor: isDisabled ? theme.colors.N50 : theme.colors.B300,
        },
    },
    "&[disabled]": {
        cursor: "not-allowed"
    },
    "&::placeholder": {
        fontSize: theme.fontSizes.desktop.body,
    },
    [theme.breakpoint.down("md")]: {
        fontSize: theme.fontSizes.mobile.body,
        "&::placeholder": {
            fontSize: theme.fontSizes.mobile.body,
        },
    }
}))

export const SelectInnerWrapper = styled.div(({theme}) => ({
    position: "relative",
    width: "100%",
    height: "100%",
    "& > svg": {
        pointerEvents: "none",
        position: "absolute",
        top: 22,
        right: 22,
    }
}))